import Constants from "../utils/consts";
import Utils from "../utils/utils";

var http = require("follow-redirects").https;
var fs = require("fs");
var qs = require("querystring");

export default async function getLezioneRecuperata(
  username,
  token,
  idRichiestaRecupero
) {
  console.log("idRichiestaRecupero", idRichiestaRecupero);
  return new Promise(function(resolve, reject) {
    var options = {
      method: "POST",
      hostname: Constants.ipAddress,
      path: Constants.apisFolder + "getLezioneRecuperata.php",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Cookie: "uid=e02675a1a7516909792f6850dffcd5fe",
      },
      maxRedirects: 20,
    };

    var req = http.request(options, function(res) {
      var chunks = [];

      res.on("data", function(chunk) {
        chunks.push(chunk);
      });

      res.on("end", function(chunk) {
        var body = Buffer.concat(chunks);
        const bodyString = body.toString();
        console.log(
          "[getLezioneRecuperata] Risposta raw per ID " +
            idRichiestaRecupero +
            ":",
          bodyString.substring(0, 500)
        );
        const resp = JSON.parse(bodyString);
        console.log(
          "[getLezioneRecuperata] Note nel recupero ID " +
            idRichiestaRecupero +
            ":",
          resp.note
        );
        resolve(resp);
      });
      res.on("error", function(error) {
        console.error(error);
      });
    });

    var postData = qs.stringify({
      token: token,
      uname: username,
      id_richiesta_recupero: idRichiestaRecupero,
    });

    req.write(postData);

    req.end();
  });
}
